import React, { useEffect, useState } from 'react';
import {Platform, Text, View, StyleSheet,Button, Alert, Modal,FlatList, TextInput } from 'react-native'
import { useNavigation } from '@react-navigation/native';
import { MagnifyingGlassIcon as GlassIcon } from "react-native-heroicons/solid";
import { inline } from 'react-native-web/dist/cjs/exports/StyleSheet/compiler';
import ResourceButton from './ResourceButtons/ResoruceButton';
import { Asset } from 'expo-asset';
import * as FileSystem from 'expo-file-system';


const MyResources = (  ) => {

    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
  
          
    const jsonDir = FileSystem.documentDirectory  + 'json/';
    const resoucesDir = jsonDir + 'myresources/'

    async function ensureDirExists(dirtocheck) {
      const dirInfo = await FileSystem.getInfoAsync(dirtocheck);
      console.log("check" + dirtocheck + ":");
      console.log(dirInfo);
      if (!dirInfo.exists) {
        console.log("Json directory" + dirtocheck + "doesn't exist, creating...");
        await FileSystem.makeDirectoryAsync(dirtocheck, { intermediates: true });
      }
    }

    async function ensureMainJsonExists() {
      const fileInfo = await FileSystem.getInfoAsync(jsonDir+"main.json");
      console.log("Main JSON:")
      console.log(fileInfo)
      if (!fileInfo.exists) { 
        console.log("Json main doesn't exist, creating...");

        var mainjson = require('../assets/json/main.json');

        const jsonfile = FileSystem.writeAsStringAsync(
          jsonDir + "main.json", ( JSON.stringify(mainjson) ).toString() ,{ encoding: FileSystem.EncodingType.UTF8 } 
        )

        console.log("JSON FILE: ")
        console.log(jsonfile);
      }
    }

    async function OpenMyJson() {
      console.log("Open main JSon")
      const fileInfo = await FileSystem.getInfoAsync(jsonDir+"main.json");
      console.log("Fileinfo");
      console.log(fileInfo);
      const jsonmain = await FileSystem.readAsStringAsync( jsonDir+"main.json",{ encoding: FileSystem.EncodingType.UTF8 } );
      console.log(jsonmain);
      //console.log( JSON.stringify(jsonmain) );
      setData( JSON.parse(jsonmain) );
      return jsonmain;
    }


    let GetResoucesDir = (resourceID) => {
      return resoucesDir + resourceID + ".json";
    }
  
    
    useEffect(() => {

      ensureDirExists(jsonDir).then(
        () => ensureDirExists(resoucesDir)
      ).then(
        () => ensureMainJsonExists()
      ).then(
        () => OpenMyJson()
      ).then(
        () => setLoading(false)
      );
  
    }, []);


  
    return (
      <View style={styles.mainview}>
        <Text>Versión web: </Text>
        <Text/>
        <View style={styles.searchview}>
          <GlassIcon style={{height:30}}/>
          <TextInput style={{paddingLeft:12, marginLeft:12}}  placeholder="Curso... "/>
        </View>
        <Text> Mis Recursos :</Text>
        <Text/>
        {isLoading ? <Text>Loading...</Text> : 
          <View>
            <Text>Version: {data["version"]} </Text>
            <Text/>
            <FlatList
              data={data["misrecursos"]}
              renderItem={ ({item: resource}) => (
                <ResourceButton
                  codigo = {resource["codigo"]}
                  nombre = {resource["nombre"]}
                  ejes = {resource["ejes"]}
                  tags = {resource["tags"]}
                  url = {resource["location"]}
                  version = {resource["version"]}
                />
              )}
            />
          </View>
        }
  
  
      </View>
    );
      
    };
    
    /*
  
    */
  
    
    const styles = StyleSheet.create({
  
      searchview: {
        padding: 6,
        flexDirection: 'row',
        flexGrow: 1,
        backgroundColor: '#C4C4C6',
        maxWidth: 232,
        height: Platform.OS != 'web' ? 44 : 42,
      }
    });
    
    export default MyResources